import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './MyAccountOrdineSectionHead.module.sass'
import { UserType } from '@utils/types'


interface Props {
  title?: string
  userType?: UserType
  children?: React.ReactNode
  className?: string
}

const MyAccountOrdineSectionHead = (props: Props) => {

  const { 
    title,
    userType,
    children,
    className = '',
  } = props

  return (
    <div className={cn(styles.root, className)}>
      {!!title && <h3 className={styles.title}>{title}</h3>}
      {children}
    </div>
  )
}

export default MyAccountOrdineSectionHead
